import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseComponent } from '../../../../models/base/base-component';
import { TabBarItem } from '../tab-bar/tab-bar-item';

@Component({
  selector: 'app-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss']
})
export class PageHeaderComponent extends BaseComponent {
  // Ensure title and description is localized before being passed in
  @Input() title: string = '';
  @Input() description: string = '';
  @Input() showBackButton: boolean = false;
  // Ensure actionButtonLabel is localized before being passed in
  @Input() actionButtonLabel: string = '';
  @Input() isLoading: boolean = false;
  @Input() tabs: TabBarItem[] = [];
  @Input() includeBanner: boolean = false;
  @Input() isSystemBanner: boolean = false;
  @Output() actionButtonClicked = new EventEmitter();
  @Output() backButtonClicked = new EventEmitter();
  @Output() selectedTab = new EventEmitter<TabBarItem>(true);

  setupBindings(): void {}

  setupViews(): void {}
}
